module.exports = __webpack_public_path__ + "static/media/team.c3191a0c.webp";